import { observable, action } from "mobx";
import _ from "lodash";
class WorkshopDetails {
  @observable workshop = {
    modules: []
  };

  @observable role = null;

  @observable openedType = { type: "workshop" };

  @observable modulesState = new Map();

  @observable questionState = new Map();

  @action setWorkshop = data => {
    this.workshop = {
      ...{
        modules: [],
        add_modules: true,
      },
      ...data,
    };
    this.initModulesState();
  };

  @action clearWorkshop = () => {
    this.workshop = { modules: [] };
    this.openedType = { type: "workshop" };
    this.role = null;
  };

  @action changeOpenedType = data => {
    this.openedType = data;
  };

  @action setRole = role => {
    this.role = role;
  };

  @action initModulesState = () => {
    let newModulesState = new Map();
    let newQuestionState = new Map();
    if (this.workshop.modules)
      this.workshop.modules.forEach(module => {
        let canSetModuleComplete = true;
        let canSetModuleSubmit = true;
        if (module.questions) {
          module.questions.forEach(question => {
            if (question.status !== "question_completed")
              canSetModuleComplete = false;
            if (
              question.status !== "question_submited" &&
              question.status !== "question_completed"
            )
              canSetModuleSubmit = false;
          });
          newModulesState.set(module.id, {
            canSetModuleComplete: canSetModuleComplete,
            canSetModuleSubmit: canSetModuleSubmit
          });
        }
      });
    this.modulesState = newModulesState;
  };

  @action addAnswer = (moduleIndex, questionIndex, answer) => {
    this.initModulesState();
  };

  @action updateModule = module => {
    let moduleIndex = _.findIndex(
      this.workshop.modules,
      el => el.id === module.id
    );
    this.workshop.modules[moduleIndex] = module;
    this.initModulesState();
    const notCompletedIndex = _.findIndex(this.workshop.modules, el => el.status !== 'module_completed');
    this.workshop.status = !this.workshop.modules[notCompletedIndex] ? 'workshop_completed' : '';
  };

  @action setSubmiteddModule = id => {
    let moduleIndex = _.findIndex(this.workshop.modules, el => el.id === id);
    this.workshop.modules[moduleIndex].status = "module_submited";
  };

  @action setCompletedModule = id => {
    let moduleIndex = _.findIndex(this.workshop.modules, el => el.id === id);
    this.workshop.modules[moduleIndex].status = "module_completed";
  };

  @action setCompletedModuleByIdx = idx => {
    this.workshop.modules[idx].status = "module_completed";
  }

  @action setModules = data => {
    this.workshop.add_modules = data;
  };

  @action approveModule = data => {
    this.workshop.workshop_state = data;
  };

  @action setGoverningBody = data => {
    this.workshop.governing_body = data;
  };

  @action setPendingStatus = () => {
    this.workshop.status = "pending";
  };

  @action
  updateCost(cost, code) {
    this.workshop = _.assign({}, this.workshop, { cost: cost, code: code });
  }
}

export default new WorkshopDetails();



// WEBPACK FOOTER //
// ./src/stores/WorkshopDetails.js